'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Base = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = function css(props) {
  return props.css;
};

var Base = exports.Base = (0, _components2.default)({}, 'space', 'color', 'fontSize', css);

Base.displayName = 'Base';

exports.default = Base;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Base.js
// module id = 2052
// module chunks = 168707334958949